import SmoothScroll from "@/components/site/SmoothScroll";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import FeatureIntro from "@/components/site/FeatureIntro";
import ThreeSteps from "@/components/site/ThreeSteps";
import ProductBanner from "@/components/site/ProductBanner";
import ProductGallery from "@/components/site/ProductGallery";
import Products from "@/components/site/Products";
import BenefitsGrid from "@/components/site/BenefitsGrid";
import Process from "@/components/site/Process";
import PriceComparison from "@/components/site/PriceComparison";
import SavingsCalculator from "@/components/site/SavingsCalculator";
import Pricing from "@/components/site/Pricing";
import Testimonials from "@/components/site/Testimonials";
import ContactForm from "@/components/site/ContactForm";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";

export default function Landing() {
  return (
    <SmoothScroll>
      <main data-testid="landing-main" className="relative">
        <Navbar />
        <Hero />
        <FeatureIntro />
        <ThreeSteps />
        <ProductBanner />
        <ProductGallery />
        <Products />
        <BenefitsGrid />
        <Process />
        <PriceComparison />
        <SavingsCalculator />
        <Pricing />
        <Testimonials />
        <ContactForm />
        <Footer />
        <WhatsAppFloat />
      </main>
    </SmoothScroll>
  );
}
